import apiClient from '../connections/api'

const getUnidades = () => {
    return apiClient.get('/units/getUnits')
}

export default {
    getUnidades
}
